var React = require('react');

function Hammer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M410 32h-52c-3.3 0-6 2.7-6 6v5.6c-4 4-10.9 9.8-17.8 9.8-10.5 0-14.8-16.4-26.1-18.4s-27.2-3-37.9-3-52 .7-102 21.5-71.7 64.9-72.3 81.4c-.3 8.7 2.7 21.1 10 11.1 7.3-10 35.3-42.3 57.7-44.7 22.3-2.3 45.7.8 63.7 17.2 17.3 15.7 21.3 30.8 21.3 73.5l-6.6 2c-4.3 1.3-7 5.7-7 9 0 0-.2 6.5-.2 70.4C234.8 368 224 474 224 474c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6 0 0-10.8-106-10.8-200.6 0-63.9-.2-70.4-.2-70.4 0-3.3-2.3-7.8-7-9l-8-2c0-38.2-.4-54 6.3-65.9 7-12.4 22.3-22.9 29.7-25.1 5.9-1.8 16 1.3 22 6.5V122c0 3.3 2.7 6 6 6h52c3.3 0 6-2.7 6-6V38c0-3.3-2.7-6-6-6z"}));
}

Hammer.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Hammer;

Hammer.default = Hammer;
